import React, { useState, useContext, useEffect } from 'react';
import './index.css'; 
import { 
    FaUser, 
    FaCalendarAlt, 
    FaIdCard, 
    FaBuilding, 
    FaMapMarkerAlt, 
    FaEnvelope, 
    FaPhone
} from 'react-icons/fa';
import { Form, InputGroup, Col, Row, Button, Card, Spinner } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { NotificationContext } from '../../contexts/notification-context';
import profissionaisService from '../../api/profissionaisService';
import especialidadesService from '../../api/especialidadesService';
import { useNavigate, useParams } from 'react-router-dom';

const UFS = [
    { sigla: 'AC', nome: 'Acre' },
    { sigla: 'AL', nome: 'Alagoas' },
    { sigla: 'AP', nome: 'Amapá' },
    { sigla: 'AM', nome: 'Amazonas' },
    { sigla: 'BA', nome: 'Bahia' },
    { sigla: 'CE', nome: 'Ceará' },
    { sigla: 'DF', nome: 'Distrito Federal' },
    { sigla: 'ES', nome: 'Espírito Santo' },
    { sigla: 'GO', nome: 'Goiás' },
    { sigla: 'MA', nome: 'Maranhão' },
    { sigla: 'MT', nome: 'Mato Grosso' },
    { sigla: 'MS', nome: 'Mato Grosso do Sul' },
    { sigla: 'MG', nome: 'Minas Gerais' },
    { sigla: 'PA', nome: 'Pará' },
    { sigla: 'PB', nome: 'Paraíba' },
    { sigla: 'PR', nome: 'Paraná' },
    { sigla: 'PE', nome: 'Pernambuco' },
    { sigla: 'PI', nome: 'Piauí' },
    { sigla: 'RJ', nome: 'Rio de Janeiro' },
    { sigla: 'RN', nome: 'Rio Grande do Norte' },
    { sigla: 'RS', nome: 'Rio Grande do Sul' },
    { sigla: 'RO', nome: 'Rondônia' },
    { sigla: 'RR', nome: 'Roraima' },
    { sigla: 'SC', nome: 'Santa Catarina' },
    { sigla: 'SP', nome: 'São Paulo' },
    { sigla: 'SE', nome: 'Sergipe' },
    { sigla: 'TO', nome: 'Tocantins' },
];

const CadastroProfissionais = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { addNotification } = useContext(NotificationContext); 
    const [especialidades, setEspecialidades] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchEspecialidades = async () => {
            try {
                const response = await especialidadesService.listar();
                setEspecialidades(response);
            } catch (err) {
                console.error('Erro ao buscar especialidades', err);
            }
        };

        fetchEspecialidades();
        if (id) {
            const carregarProfissional = async () => {
                try {
                    setLoading(true);
                    const profissional = await profissionaisService.obter(id); 
                    setFormData(profissional);
                  } catch (err) {
                    console.error('Erro ao carregar profissional:', err);
                    addNotification('danger', 'Erro ao carregar profissional. Por favor, tente novamente.');
                  } finally {
                    setLoading(false);
                  }
            }            
            carregarProfissional();
        }
    }, [id]);

    const [formData, setFormData] = useState({
        nome: '',
        cpf: '',
        tipoConselho: '',
        ufConselho: '',
        numeroRegistro: '',
        email: '',
        dataNascimento: '',
        telefone: '',
        externo: false,
        especialidadeId: '',
    });


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        
        try {
            if (id) {
                await profissionaisService.atualizar(id, formData);
                addNotification('success', 'Profissional alterado com sucesso!');
            }else {
                await profissionaisService.inserir(formData);
                addNotification('success', 'Profissional cadastrado com sucesso!');

                setFormData({
                    nome: '',
                    cpf: '',
                    tipoConselho: '',
                    ufConselho: '',
                    numeroRegistro: '',
                    email: '',
                    dataNascimento: '',
                    telefone: '',
                    externo: false,
                    especialidadeId: '',
                });
            }
            
        } catch (err) {
            console.error('Erro ao criar profissional:', err);
            addNotification('danger', `Erro ao criar profissional. ${err?.Message}`);
            } finally {
            setLoading(false);
            }
        }

    return (
        <div className="cadastro-profissionais-container">
            <Card className="cadastro-profissionais-card shadow-sm">
                <Card.Body>
                <Card.Title className="text-center mb-4">Cadastro de Profissionais</Card.Title>
                <hr></hr>
                <Form onSubmit={handleSubmit} className="cadastro-profissionais-form">
                    <Row>
                        <Col md={8} sm={12}  className="mb-3">
                            <Form.Group controlId="nome">
                                <Form.Label>Nome</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaUser />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        required
                                        placeholder="Digite o nome"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Nome é obrigatório.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={4} sm={12}  className="mb-3">
                            <Form.Group controlId="dataNascimento">
                                <Form.Label>Data de Nascimento</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaCalendarAlt />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="date"
                                        name="dataNascimento"
                                        value={formData.dataNascimento ? new Date(formData.dataNascimento).toISOString().split('T')[0] : ''}
                                        onChange={handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Data de Nascimento é obrigatória.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} sm={12}  className="mb-3">                        
                            <Form.Group controlId="especialidade">
                                <Form.Label>Especialidade</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaMapMarkerAlt />
                                    </InputGroup.Text>
                                    <Form.Control
                                        as="select"
                                        className="form-select"
                                        name="especialidadeId" 
                                        value={formData.especialidadeId || ''} 
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Selecione uma especialidade</option>
                                        {especialidades?.map(especialidade => (
                                            <option key={especialidade.id} value={especialidade.id}>
                                                {especialidade.nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Especialidade é obrigatória.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={3} sm={12}  className="mb-3">
                            <Form.Group controlId="tipoConselho">
                                <Form.Label>Tipo de Conselho</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaBuilding />
                                    </InputGroup.Text>
                                    <Form.Control
                                        as="select"
                                        className="form-select"
                                        name="tipoConselho"
                                        value={formData.tipoConselho}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Selecione</option>
                                        <option value="1">CRP</option>
                                        <option value="2">CRFa</option>
                                        <option value="3">CRN</option>
                                        <option value="4">Crefito</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Tipo de Conselho é obrigatório.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={3} sm={12}  className="mb-3">
                            <Form.Group controlId="numeroRegistro">
                                <Form.Label>Número de Registro</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaIdCard />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        name="numeroRegistro"
                                        value={formData.numeroRegistro}
                                        onChange={handleChange}
                                        required
                                        placeholder="Digite o número de registro"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Número de Registro é obrigatório.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={2} sm={12}  className="mb-3">
                            <Form.Group controlId="ufConselho">
                                <Form.Label>UF</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaMapMarkerAlt />
                                    </InputGroup.Text>
                                    <Form.Control
                                        as="select"
                                        className="form-select"
                                        name="ufConselho"
                                        value={formData.ufConselho}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Selecione uma UF</option>
                                        {UFS.map(uf => (
                                            <option key={uf.sigla} value={uf.sigla}>
                                                {uf.sigla}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        UF do Conselho é obrigatório.
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} sm={12}  className="mb-3">
                            <Form.Group controlId="cpf">
                                <Form.Label>CPF</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaIdCard />
                                    </InputGroup.Text>
                                    <InputMask
                                        mask="999.999.999-99"
                                        value={formData.cpf}
                                        onChange={handleChange}
                                    >
                                        {(inputProps) => (
                                            <Form.Control
                                                {...inputProps}
                                                type="text"
                                                name="cpf"
                                                required
                                                placeholder="Digite o CPF"
                                            />
                                        )}
                                    </InputMask>
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={4} sm={12} className="mb-3">
                            <Form.Group controlId="telefone">
                                <Form.Label>Telefone</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaPhone />
                                    </InputGroup.Text>
                                    <InputMask
                                        mask="(99) 99999-9999" 
                                        value={formData.telefone}
                                        onChange={handleChange}
                                    >
                                        {(inputProps) => (
                                            <Form.Control
                                                {...inputProps}
                                                type="text"
                                                name="telefone"
                                                required
                                                placeholder="Digite o telefone"
                                            />
                                        )}
                                    </InputMask>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={6} sm={12} className="mb-3">
                            <Form.Group controlId="email">
                                <Form.Label>E-mail</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FaEnvelope />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="Digite o e-mail"
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col md={2} sm={12} className="mb-3">
                            <Form.Group controlId="externo">
                                <Form.Label>Externo</Form.Label>
                                <InputGroup>
                                    <Form.Check
                                        type="switch"
                                        id="externo-switch"
                                        name="externo"
                                        checked={formData.externo}
                                        onChange={handleChange}
                                        label=""
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col className="text-start"> 
                            <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            className="me-2"
                            >
                            {loading ? (
                                <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                />
                            ) : (
                                id ? 'Alterar' : 'Cadastrar'
                            )}
                            </Button>
                            <Button variant="secondary" onClick={() => navigate('/lista-profissionais')}>
                            Voltar
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
            </Card>
        </div>
    );

};

export default CadastroProfissionais;
